import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

/**
 * Initializes grid gallery on the page
 */
export function initGridGallery() {
  const galleries = document.querySelectorAll('.grid-gallery');

  if (galleries.length === 0) {
    return;
  }

  for (const gallery of galleries) {
    if (gallery instanceof HTMLElement) {
      renderGridGallery(gallery);
    }
  }
}

/**
 * Renders a single grid gallery
 * @param {HTMLElement} galleryContainer - The grid gallery container element
 */
function renderGridGallery(galleryContainer) {
  if (!galleryContainer) {
    return;
  }

  // Convert your existing <img> tags into "items" PhotoSwipe can use.
  // Easiest pattern: wrap images in <a> with href pointing to full-size image.
  // But since your markup is already rendered, we’ll:
  // 1) Find each <img>
  // 2) Wrap it in an <a> dynamically
  // 3) Use src (or srcset) as the large image URL

  const images = galleryContainer.querySelectorAll('.et_pb_image_wrap img');

  images.forEach((img) => {
    // If it's already wrapped in a link, skip
    if (img.parentElement.tagName.toLowerCase() === 'a') {
      return;
    }

    const fullSrc = img.getAttribute('src');

    // Create a link wrapper
    const link = document.createElement('a');
    link.href = fullSrc;
    link.setAttribute('data-pswp-width', img.naturalWidth || img.width || 1200);
    link.setAttribute(
      'data-pswp-height',
      img.naturalHeight || img.height || 800,
    );

    // Optional: caption from alt/title
    const caption = img.getAttribute('alt') || img.getAttribute('title') || '';
    if (caption) {
      link.setAttribute('data-pswp-caption', caption);
    }

    // Insert link in DOM
    const wrap = img.parentElement; // .et_pb_image_wrap
    wrap.replaceChild(link, img);
    link.appendChild(img);
  });

  // Initialize PhotoSwipe Lightbox with auto-generated root container
  const lightbox = new PhotoSwipeLightbox({
    gallery: '.grid-gallery',
    children: '.et_pb_image_wrap a',
    pswpModule: PhotoSwipe,

    // This tells PhotoSwipe to create the .pswp root itself:
    appendTo: document.body,

    // Reserve space for thumbnails + caption
    paddingFn: () => {
      return {
        top: 20,
        bottom: 120, // 👈 adjust this height to match your thumb strip
        left: 0,
        right: 0,
      };
    },
  });

  // Add caption support
  lightbox.on('uiRegister', function () {
    lightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (el, pswp) => {
        pswp.on('change', () => {
          const currSlide = pswp.currSlide;
          const caption = currSlide.data.element.dataset.pswpCaption || '';
          el.innerHTML = caption || '';
          el.style.padding = caption ? '10px 20px' : '0';
        });
      },
    });

    // 4) Thumbnail strip navigation
    lightbox.pswp.ui.registerElement({
      name: 'thumbs',
      className: 'pswp__thumbs',
      appendTo: 'root', // overlay on content, like bullets example
      onInit: (el, pswp) => {
        const thumbs = [];
        let prevIndex = -1;

        const dataSource = pswp.options.dataSource;
        // When using gallery/children, dataSource is { gallery, items: [elements...] }
        const items = Array.isArray(dataSource) ? dataSource : dataSource.items;

        for (let i = 0; i < pswp.getNumItems(); i++) {
          const thumbButton = document.createElement('button');
          thumbButton.type = 'button';
          thumbButton.className = 'pswp__thumb';

          const thumbImg = document.createElement('img');

          // Try to pull thumbnail img from the original DOM element
          const itemEl = items[i];
          const imgEl = itemEl.querySelector('img');

          thumbImg.src = imgEl ? imgEl.src : itemEl.getAttribute('href');
          thumbImg.alt = imgEl ? imgEl.alt || '' : '';

          thumbButton.appendChild(thumbImg);

          thumbButton.addEventListener('click', () => {
            pswp.goTo(i);
          });

          el.appendChild(thumbButton);
          thumbs.push(thumbButton);
        }

        // Highlight active thumb + auto-scroll into view
        pswp.on('change', () => {
          if (prevIndex >= 0 && thumbs[prevIndex]) {
            thumbs[prevIndex].classList.remove('pswp__thumb--active');
          }

          const current = thumbs[pswp.currIndex];
          if (current) {
            current.classList.add('pswp__thumb--active');
            current.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          }

          prevIndex = pswp.currIndex;
        });
      },
    });
  });

  lightbox.init();
}
